import Big from 'big.js'

import {useCurrencySymbol} from '@/lib/locale/country'
import formatNumber, {Format} from '@/utils/numbers/formatNumber'

interface PriceProps {
  price?: string |number | bigint | Big | undefined
  options?: Parameters<typeof formatNumber>[2]
}

export default memo(function Price(props: PriceProps) {
  const currencySymbol = useCurrencySymbol()
  const numberNum =
    props.price && props.price instanceof Big ? props.price.toNumber() : (props.price ?? 0)
  let numberString = formatNumber(numberNum, Format.READABLE, props.options)
  let sign = ''
  if (numberString.startsWith('-')) {
    numberString = numberString.slice(1)
    if (numberNum !== 0) sign = '-' // prevent showing '-' for 0
  }

  return (
    <>
      {sign}
      {currencySymbol}
      {numberString}
    </>
  )
})
